module.exports = __webpack_public_path__ + "img/christmas.4f9467fe.jpg";